//**auto-generated don't edit this code**//
import {ContractHttpClient, getClientConfig} from '@esgi/contracts';
import {Disposable} from '@esgi/core/service';
import {login} from './endpoints/login';
import {loginByClassLink} from './endpoints/login-by-class-link';
import {devLogin} from './endpoints/dev-login';
import {byCrmToken} from './endpoints/by-crm-token';
import {byLinkedClever} from './endpoints/by-linked-clever';
import {byAgreement} from './endpoints/by-agreement';
import {byRegistration} from './endpoints/by-registration';
import {byRenew} from './endpoints/by-renew';
import {logout} from './endpoints/logout';
import {forceLogout} from './endpoints/force-logout';
import {remindPassword} from './endpoints/remind-password';

export class LoginController implements Disposable {
	private httpClientConfig = getClientConfig('esgi-apigateway');
	private httpClient: ContractHttpClient = new ContractHttpClient(this.httpClientConfig);

	public login = login(this.httpClient);
	public loginByClassLink = loginByClassLink(this.httpClient);
	public devLogin = devLogin(this.httpClient);
	public byCrmToken = byCrmToken(this.httpClient);
	public byLinkedClever = byLinkedClever(this.httpClient);
	public byAgreement = byAgreement(this.httpClient);
	public byRegistration = byRegistration(this.httpClient);
	public byRenew = byRenew(this.httpClient);
	public logout = logout(this.httpClient);
	public forceLogout = forceLogout(this.httpClient);
	public remindPassword = remindPassword(this.httpClient);

	public dispose(): void {
		this.httpClient?.destroy();
	}
}
